import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiConfirmSection from "../foto-multi-confirm-section/FotoMultiConfirmSection";
import { Section } from "../styled/Containers.style";
import carta_circolazione_img from './../../assets/img/carta_circolazione.png'
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

const TOT_FOTO_CARTA_CIRCOLAZIONE = 2

export interface FotoCartaCircolazioneProps {
    onTotFotoIsRiched: any
}

/* istanbul ignore next */
const FotoCartaCircolazione = ({ onTotFotoIsRiched }: FotoCartaCircolazioneProps) => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData

    const [fotoCartaCircolazione, setFotoCartaCircolazione] = useState<FileItemType[]>(communication.fotoCartaCircolazione)
    const fotoPresent = fotoCartaCircolazione?.length > 0

    const numPhotos = fotoCartaCircolazione?.length
    const leftLabelCmp = <p className="left-label-item">{`${numPhotos + 1} foto di ${TOT_FOTO_CARTA_CIRCOLAZIONE}`}</p>

    const labelTxt = numPhotos === 0 ? 'Fronte' : 'Retro'
    const labelItem = <p className="mail-label">{labelTxt}</p>

    return (
        <>
            {!fotoPresent && <Section>
                <img src={carta_circolazione_img}
                    alt="carta circolazione" />
            </Section>}
            <FotoMultiConfirmSection
                fileType={PhotoTypeEnum.CARTA_CIRCOLAZIONE_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.CARTA_CIRCOLAZIONE_DOCS],
                    liqDescription: "Libretto di circolazione"
                }}
                files={fotoCartaCircolazione}
                setFiles={setFotoCartaCircolazione}
                arrayDbPropSync={"fotoCartaCircolazione"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto carta circolazione"}
                leftLabelCmp={leftLabelCmp}
                mainLabelItem={labelItem}
                totPhotosForStepDone={TOT_FOTO_CARTA_CIRCOLAZIONE}
                onTotFotoIsRiched={onTotFotoIsRiched}
            />
        </>
    )
}

export default FotoCartaCircolazione